const state = {
    token: null,
    username: null,
    departmentId: null,
    idxList: null,
    year: null,
    month: null
};

const mutations = {
    login(state, token) {
        state.token = token;
    },
    logout(state) {
        state.token = null;
        state.username = null;
        state.departmentId = null;
        state.idxList = null;
    },
    setUsername( state, username ){
        state.username = username;
    },
    setDepartmentId( state, depid ){
        state.departmentId = depid;
    },
    setDepartmentListIndex( state, index ){
        state.idxList = index;
    },
    
    setYear( state, year ){
        state.year = year;
    },
    setMonth( state, month ){
        state.month = month;
    }
    
};

export default {
    state,
    mutations
}
